export type ContentType = 'image' | 'json-upload' | 'pdf';

export function getContentPath(contentType: ContentType): string {
  switch (contentType) {
    case 'image':
      return '/image';
    case 'json-upload':
      return '/json';
    case 'pdf':
      return '/pdf';
    default:
      throw new Error(`Unknown contentType ${contentType}`);
  }
}

export type ContentAccessType = 'public-device' | 'user' | 'archive' | 'kb';

export function validateContentAccessType(value: string): ContentAccessType {
  switch (value) {
    case 'public-device':
    case 'user':
    case 'archive':
    case 'kb':
      return value;
    default:
      throw new Error(`Invalid ContentAccessType: ${value}`);
  }
}
